import { Link } from "react-router-dom";
import { buttonClass } from "@jkast90/kast-common/ui";
import { AccountCorner } from "@common/components/AccountControls";
import styles from "./HomePage.module.css";

export default function HomePage() {
  return (
    <div className={styles.page}>
      <AccountCorner />
      <div className={styles.hero}>
        <img src="/kd_logo.png" alt="KD Logo" className={styles.logo} />
        <h1 className={styles.name}>Jeremy Kast</h1>
        <p className={styles.tagline}>
          Full Stack Network Automation Engineer based out of Colorado Springs. Apparently you've found my corner of the
          internet.
        </p>
      </div>

      <div className={styles.buttons}>
        <Link to="/resume" className={buttonClass({ className: styles.button })}>
          My Resume
        </Link>
        <a
          href="https://github.com/jkast90"
          target="_blank"
          rel="noopener noreferrer"
          className={buttonClass({ className: styles.button })}
        >
          GitHub
        </a>
      </div>
    </div>
  );
}
